import React, { Component } from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import { InputMode } from 'Common/FormEnum';

import { InputField } from 'Common/SemanticWrapper';
import { StyledReduxFormError } from 'Components/';

import { TAX_RATE_ENTRY_FORM_NAME } from 'Common/FormEnum';
import { TaxRateFieldEnum } from 'Common/FieldEnum';
import { isPercentValid } from 'Common/FormHelper';

class TaxRateForm extends Component {
  render() {
    const { error } = this.props;

    return (
      <Form>
        <Field name={TaxRateFieldEnum.Id} component="input" type="hidden" />
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Field
                type="text"
                name={TaxRateFieldEnum.Name}
                component={InputField}
                label="Name"
                maxLength={20}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                type="number"
                name={TaxRateFieldEnum.Free}
                component={InputField}
                label="Free"
                maxLength={7}
                labelPosition="right"
                mode={InputMode.Decimal}
                numericSize={[6, 3]}
                fieldLabel={{ basic: true, content: '%' }}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                type="number"
                name={TaxRateFieldEnum.Reduced}
                component={InputField}
                label="Reduced"
                maxLength={7}
                labelPosition="right"
                mode={InputMode.Decimal}
                numericSize={[6, 3]}
                fieldLabel={{ basic: true, content: '%' }}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                type="number"
                name={TaxRateFieldEnum.Paid}
                component={InputField}
                label="Paid"
                maxLength={7}
                labelPosition="right"
                mode={InputMode.Decimal}
                numericSize={[6, 3]}
                fieldLabel={{ basic: true, content: '%' }}
              />{' '}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                type="number"
                name={TaxRateFieldEnum.Teacher}
                component={InputField}
                label="Teacher"
                maxLength={7}
                labelPosition="right"
                mode={InputMode.Decimal}
                numericSize={[6, 3]}
                fieldLabel={{ basic: true, content: '%' }}
              />{' '}
            </Grid.Column>
            <Grid.Column>
              <Field
                type="number"
                name={TaxRateFieldEnum.Adult}
                component={InputField}
                label="Adult"
                maxLength={7}
                labelPosition="right"
                mode={InputMode.Decimal}
                numericSize={[6, 3]}
                fieldLabel={{ basic: true, content: '%' }}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                type="number"
                name={TaxRateFieldEnum.SchoolFoodService}
                component={InputField}
                label="School food service"
                maxLength={7}
                labelPosition="right"
                mode={InputMode.Decimal}
                numericSize={[6, 3]}
                fieldLabel={{ basic: true, content: '%' }}
              />{' '}
            </Grid.Column>
            <Grid.Column>
              <Field
                type="number"
                name={TaxRateFieldEnum.Catering}
                component={InputField}
                label="Catering"
                maxLength={7}
                labelPosition="right"
                mode={InputMode.Decimal}
                numericSize={[6, 3]}
                fieldLabel={{ basic: true, content: '%' }}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <StyledReduxFormError error={error} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  if (!values[TaxRateFieldEnum.Name]) {
    errors[TaxRateFieldEnum.Name] = 'Name is required';
  }

  if (!isPercentValid(values[TaxRateFieldEnum.Free])) {
    errors[TaxRateFieldEnum.Free] = 'Free should be a number between 0 and 100';
  }
  if (!isPercentValid(values[TaxRateFieldEnum.Paid])) {
    errors[TaxRateFieldEnum.Paid] = 'Paid should be a number between 0 and 100';
  }
  if (!isPercentValid(values[TaxRateFieldEnum.Adult])) {
    errors[TaxRateFieldEnum.Adult] =
      'Adult should be a number between 0 and 100';
  }
  if (!isPercentValid(values[TaxRateFieldEnum.Reduced])) {
    errors[TaxRateFieldEnum.Reduced] =
      'Reduced should be a number between 0 and 100';
  }
  if (!isPercentValid(values[TaxRateFieldEnum.Teacher])) {
    errors[TaxRateFieldEnum.Teacher] =
      'Teacher should be a number between 0 and 100';
  }
  if (!isPercentValid(values[TaxRateFieldEnum.SchoolFoodService])) {
    errors[TaxRateFieldEnum.SchoolFoodService] =
      'School Food Service should be a number between 0 and 100';
  }
  if (!isPercentValid(values[TaxRateFieldEnum.Catering])) {
    errors[TaxRateFieldEnum.Catering] =
      'Catering should be a number between 0 and 100';
  }
  if (props.initialValues && props.initialValues[TaxRateFieldEnum.Name]) {
    if (
      props.usedTaxRateNames &&
      props.usedTaxRateNames.includes(values[TaxRateFieldEnum.Name].trim()) &&
      props.initialValues[TaxRateFieldEnum.Name] !==
        values[TaxRateFieldEnum.Name]
    ) {
      errors[TaxRateFieldEnum.Name] = 'Tax Rate name must be unique';
    }
  } else {
    if (
      props.usedTaxRateNames &&
      values[TaxRateFieldEnum.Name] &&
      props.usedTaxRateNames.includes(values[TaxRateFieldEnum.Name].trim())
    ) {
      errors[TaxRateFieldEnum.Name] = 'Tax Rate name must be unique';
    }
  }

  return errors;
};

export default reduxForm({
  form: TAX_RATE_ENTRY_FORM_NAME,
  validate,
})(TaxRateForm);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/taxRates/TaxRateForm.js